function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35.467 48.447c.364.168 4.929 2.871 4.929 2.871s3.083 2.16 3.999 2.548c11.432 4.746-.458 5.78-3.488 4.798-1.494-.492-9.587-5.225-12.51-10.217-.592-1.009 3.367-1.681 7.07 0z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.837 43.286c1.549 1.488 2.68 3.298 1.09 5.38-2.423 1.902-7.594 3.285-9.398-.918-1.764-4.112.942-5.78 2.962-6.052 2.195-.285 5.346 1.577 5.346 1.577v.013z",
  fill: "#FBE0D0",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.839 70.368c-1.266 3.841 1.629 7.385 3.487 8.588 1.859 1.202 5.373.775 5.589 3.724.107 1.578-1.428 2.082-2.034 3.052-1.737 2.768.862 9.053 6.464 8.187 8.78-1.358 12.752-12.273 9.87-18.843-2.881-6.583-20.333-13.916-23.376-4.695v-.013z",
  fill: "#F2DE89"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M49.646 73.679c2.855.517 8.834 1.008 11.904 4.54 3.07 3.53 2.155 7.772.647 9.893-1.509 2.12-6.693 5.16-7.582-.647-.336-2.173 4.74-2.806 3.69-4.914-1.05-2.108-4.376-2.083-6.06-3.583-1.683-1.5-3.137-5.445-3.137-5.445",
  fill: "#804F21"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.839 70.368c-1.266 3.841 1.629 7.385 3.487 8.588 1.859 1.202 5.373.775 5.589 3.724.107 1.578-1.428 2.082-2.034 3.052-1.737 2.768.862 9.053 6.464 8.187 8.78-1.358 12.752-12.273 9.87-18.843-2.881-6.583-20.333-13.916-23.376-4.695v-.013z",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.228 66.177c-2.99-5.988-7.339-3.013-7.406-.737-.121 3.996 3.528 8.69 5.494 8.549 1.966-.143 2.262-.272 2.99-1.462.969-1.604-1.078-6.35-1.078-6.35z",
  fill: "#804F21"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.419 54.357c-3.42 1.642-8.74 4.397-7.703 13.243.754 6.428 10.611 8.898 12.483 8.794 1.872-.09 6.208-2.16 7.662-13.243.337-2.548.498-6.453-3.407-8.872-3.905-2.418-6.598-1.086-9.035.078zM47.33 12.622c-2.949-4.746.324-10.333 4.74-10.605 4.417-.271 8.524 2.703 7.837 7.462-.686 4.76-8.59 9.545-12.577 3.143z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M50.159 11.42c-1.455-2.367.175-5.16 2.37-5.303 2.195-.142 4.241 1.345 3.891 3.724-.35 2.38-4.282 4.773-6.261 1.578z",
  fill: "#804F21"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.097 46.804c-4.875-4.359-6.935-12.416-7.15-15.028-.216-2.613-.135-10.747 8.187-16.593 8.012-5.626 16.105-5.16 20.67-3.764 4.565 1.397 13.197 4.76 17.829 9.907 4.632 5.147 8.78 12.506 7.097 18.986-1.67 6.479-6.841 14.342-14.45 15.7-7.608 1.358-14.327 1.875-22.057-1.901-7.729-3.776-10.126-7.294-10.126-7.294v-.013z",
  fill: "#F2DE89"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M34.04 27.069c3.81 2.017 10.785 1.487 12.28.31.202 3.207 9.44 11.433 8.928 10.89 0 0-6.087 14.381-9.13 16.114-9.076-2.315-14.866-9.519-17.169-13.993-1.387-4.23 4-13.49 5.09-13.321z",
  fill: "#FBE0D0",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M58.628 13.14c-7.352 2.806-8.51 6.104-7.904 7.165.606 1.06 15.822-3.609 15.822-3.609-2.424-.918-7.918-3.556-7.918-3.556zM50.266 10.087c-3.676 3.078-4.754 6.247-3.569 5.82 1.185-.427 10.221-3.608 10.221-3.608-2.424-.919-6.652-2.212-6.652-2.212zM67.543 17.032c-10.329 4.203-9.332 6.635-8.147 6.208l13.223-1.914c-2.424-1.54-5.076-4.294-5.076-4.294z",
  fill: "#804F21"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.097 46.804c-4.875-4.359-6.423-11.433-7.15-15.028-.512-2.574-.135-10.747 8.187-16.593 8.012-5.626 16.105-5.16 20.67-3.764 4.565 1.397 13.197 4.76 17.829 9.907 4.632 5.147 8.78 12.506 7.097 18.986-1.67 6.479-7.178 13.152-14.45 15.7-5.601 1.966-14.327 1.875-22.057-1.901-7.729-3.776-10.126-7.294-10.126-7.294v-.013z",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.476 17.666c3.057.401.552 5.031-1.549 4.1-1.683-.75-.255-4.333 1.549-4.1z",
  fill: "#000"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M44.678 19.063c-.094-.271-.35-.465-.566-.66-.148-.142-.296-.271-.444-.413-.31-.285-.62-.57-.943-.84-.202-.17-.525-.117-.687.05a.497.497 0 00-.04.673c.27.324.539.634.822.944.134.156.269.298.403.453.202.22.377.453.674.556a.62.62 0 00.633-.13.564.564 0 00.12-.62l.028-.013z",
  fill: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.925 24.25c3.057.401.552 5.031-1.548 4.1-1.684-.75-.256-4.333 1.548-4.1z",
  fill: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M55.047 25.853c-.095-.271-.35-.465-.566-.66-.148-.142-.296-.271-.444-.413-.31-.285-.62-.57-.943-.84-.202-.169-.525-.117-.687.05a.497.497 0 00-.04.673c.27.324.539.634.821.945.135.155.27.297.404.452.202.22.377.453.674.556a.62.62 0 00.632-.13.564.564 0 00.122-.62l.026-.013z",
  fill: "#000"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M68.539 28.039c-.552-.893-1.481-2.858-1.643-3.764-.646-3.944 2.276-6.427 5.858-6.66 4.417-.272 8.524 2.703 7.837 7.462-.552 3.828-5.561 8.523-9.655 6.57-.997-.478-2.397-3.608-2.397-3.608z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M70.478 26.616c-1.454-2.367.175-5.16 2.37-5.303 2.195-.142 4.242 1.345 3.892 3.725-.35 2.38-4.282 4.772-6.262 1.578z",
  fill: "#804F21"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.68 23.564c3.057.4.552 5.03-1.548 4.1-1.684-.75-.256-4.333 1.548-4.1z",
  fill: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M35.722 62.777c1.428-2.846 6.02-2.742 8.12.051 2.114 2.807 1.549 8.161-.861 9.855-2.41 1.694-7.057-.84-7.663-3.983-.606-3.143-.282-4.566.404-5.923z",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M57.86 58.094c.31-.31 4.97-7.398 4.97-7.398s.552-1.008-.108-1.875c-.58-.776-1.899-3.66-3.34-2.664-1.44.983-5.373 5.432-7.662 10.799-.511 1.203 1.158 5.988 6.14 1.138z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M45.553 67.872c-1.818-1.06-6.14.26-7.406 5.807-.916 4.01-.189 5.885 1.239 6.7 4.565 2.573 12.28-8.95 6.154-12.507h.013z",
  fill: "#804F21"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.363 31.077c3.097.246.834 5.031-1.334 4.204-1.737-.673-.498-4.346 1.334-4.204z",
  fill: "#000"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M38.456 32.603c-.107-.271-.377-.452-.606-.633-.161-.13-.31-.26-.471-.401-.323-.272-.646-.543-.983-.79-.215-.154-.525-.09-.7.091a.496.496 0 000 .673c.282.31.579.608.889.905.148.142.296.285.43.427.216.207.404.427.714.517.229.065.471 0 .633-.168.175-.181.175-.414.094-.634v.013z",
  fill: "#000"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.51 35.928c3.096.246.834 5.03-1.334 4.203-1.737-.672-.498-4.345 1.333-4.203z",
  fill: "#000"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M46.967 37.286c-.108-.272-.377-.453-.606-.634-.161-.13-.31-.258-.471-.4-.323-.272-.647-.544-.983-.79-.216-.155-.525-.09-.7.09a.496.496 0 000 .673c.282.31.579.608.888.906.148.142.297.284.431.426.216.207.404.427.714.518.229.064.471 0 .633-.168.175-.181.175-.414.094-.634v.013z",
  fill: "#000"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M37.42 38.967c.134 6.467 4.026 8.523 4.848.828 0 0-2.115-1.759-4.848-.828z",
  fill: "#D61518"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M57.847 48.265c.755 2.807 5.144 4.152 8.066 2.859 1.913-.841 4.929-5.587.782-8.82-4.148-3.234-10.302.53-8.848 5.961z",
  fill: "#FBE0D0",
  stroke: "#40220F",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M89.21 48.136s.04.065.053.104c.014.038.027.077.04.103.149.401.135.79-.053 1.19-.081.181-.175.336-.283.504.43.078.835.233 1.145.57.484.517.255 1.59-.068 2.172-.538.983-2.168 1.32-3.056.466a2.192 2.192 0 01-.176.297 2.68 2.68 0 01-.754.686c-.525.31-1.239.388-1.804.129-1.077-.478-1.158-1.707-.754-2.677-.458-.207-.835-.543-1.037-1.022-.296-.711-.108-1.435.377-2.017.485-.57 1.077-1.022 1.885-.944.364.038.754.155 1.05.362.378-.414.849-.763 1.428-.854a1.989 1.989 0 011.98.931h.026z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M94.272 70.976s-.094.116-.148.168a.916.916 0 01-.175.142c-.62.504-1.333.776-2.168.724-.377-.026-.74-.064-1.104-.13.161.777.148 1.553-.243 2.303-.605 1.164-2.693 1.5-3.985 1.37-2.155-.232-3.852-2.715-2.922-4.771a3.701 3.701 0 01-.647-.09 5.07 5.07 0 01-1.75-.79c-.93-.672-1.535-1.797-1.455-2.923.135-2.134 2.303-3.09 4.31-3.09.067-.906.417-1.773 1.144-2.42 1.077-.97 2.518-1.163 3.905-.75 1.374.415 2.585 1.1 3.003 2.51.188.633.242 1.358.054 2.004 1.01.35 1.966.893 2.518 1.798.754 1.242.606 2.832-.337 3.945z",
  fill: "#FF919E",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M87.526 65.711c-1.79-.685-3.541 1.746-2.073 3.518 1.467 1.772 4.147.543 3.959-1.112-.19-1.656-.984-2.056-1.886-2.406z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M70.666 63.993c.916-1.617 3.286-.194 2.222 1.707-.93 1.655-3.138-.078-2.222-1.707z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 1.7,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M2.044 36.755s.068-.129.108-.194c.04-.064.08-.129.135-.168.498-.62 1.13-1.022 1.966-1.15.363-.053.74-.078 1.117-.091-.323-.725-.484-1.488-.269-2.302.337-1.255 2.303-2.018 3.595-2.147 2.155-.207 4.363 1.875 3.905 4.074.216-.026.431-.052.647-.04.66.027 1.293.156 1.885.415 1.05.465 1.899 1.448 2.074 2.56.337 2.108-1.576 3.492-3.542 3.893.135.893-.013 1.81-.592 2.6-.849 1.164-2.209 1.655-3.65 1.513-1.427-.13-2.773-.556-3.487-1.85-.323-.582-.539-1.28-.498-1.94-1.064-.142-2.115-.465-2.855-1.254a3.393 3.393 0 01-.539-3.919z",
  fill: "#FF919E",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M9.249 40.752c1.912.31 3.07-2.419 1.265-3.854-1.804-1.436-4.174.297-3.622 1.888.552 1.59 1.414 1.81 2.37 1.966H9.25z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M9.087 54.628s-.04.065-.067.104c-.027.039-.054.064-.081.09a1.59 1.59 0 01-1.091.556c-.202.013-.404.026-.592.013.148.401.215.815.067 1.242-.216.66-1.293 1.009-1.993 1.035-1.158.051-2.276-1.126-1.953-2.303-.12 0-.229.013-.35 0a2.933 2.933 0 01-.996-.284c-.552-.285-.97-.828-1.024-1.436-.107-1.138.956-1.823 2.02-1.978-.04-.479.068-.97.404-1.371.485-.595 1.24-.815 2.007-.699.754.117 1.467.375 1.804 1.087.162.323.242.698.202 1.06.566.104 1.118.31 1.495.75.511.595.565 1.462.161 2.121l-.013.013z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M19.308 52.637c.767-1.604 3.258-.246 2.356 1.63-.794 1.642-3.124-.026-2.356-1.63zM17.18 23.732c.647-1.733 3.219-.686 2.465 1.358-.66 1.771-3.111.388-2.465-1.358z",
  fill: "#F2DE89",
  stroke: "#40220F",
  strokeWidth: 1.7,
  strokeMiterlimit: 10
});

var SvgIconSue1 = function SvgIconSue1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
};

export default SvgIconSue1;